<app-dialog-header [title]="'Cadastro de colaborador'"></app-dialog-header>

<mat-dialog-content class="collaborator-dialog__content">
  <form [formGroup]="form">
    <div class="collaborator-invitation">
      <div class="collaborator-invitation__contact">
        <div class="collaborator-invitation__field">
          <div class="form-group">
            <label class="form-label" for="email">E-mail</label>
            <div>
              <input
                placeholder="Email do colaborador"
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                inputmode="email"
                [ngClass]="{
                  'is-invalid': controls.email.invalid && controls.email.touched,
                }" />

              @if (controls.email.touched && controls.email.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
        <div class="collaborator-invitation__field">
          <label class="form-label" for="phone">Telefone</label>
          <div class="form-group form-phone">
            <app-ddi-select formControlName="ddi"></app-ddi-select>
            <input
              placeholder="Telefone do colaborador"
              type="phone"
              class="form-control"
              id="phone"
              formControlName="phone"
              inputmode="numeric"
              placeholder="(00) 00000-0000"
              [mask]="controls.ddi.value === '+55' ? '(00) 00000-0000' : ''"
              [ngClass]="{
                'is-invalid': controls.phone.invalid && controls.phone.touched,
              }" />
          </div>
          @if (controls.phone.touched && controls.phone.hasError("required")) {
            <div class="text-danger">Esse campo é obrigatório.</div>
          }
          @if (controls.phone.touched && controls.phone.hasError("invalidPhoneNumber")) {
            <div class="text-danger">Formato inválido, informe apenas os números.</div>
          }
        </div>
      </div>
      <app-pdv-access-fields [controls]="controls" [operatorsOnly]="!!data.operatorsOnly" />
      @if (apiError) {
        <p role="alert" class="text-danger">{{ apiError }}</p>
      }
      <!-- <div class="row">
        <div class="col">
          <label class="form-label" for="channel">Por qual meio o colaborador deve receber o convite?</label>
          <select
            id="channel"
            class="form-select"
            aria-label="Selecione a função do colaborador"
            formControlName="channel">
            <option value="" disabled>Selecione um canal</option>
            <option [value]="channelEnum.EMAIL">E-mail</option>
            <option [value]="channelEnum.WHATSAPP">Whatsapp</option>
            <option [value]="channelEnum.SMS">SMS</option>
          </select>
        </div>
      </div> -->
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="collaborator-dialog__actions">
  <app-button styleType="outlined" (btnClick)="dialogRef.close()" [disabled]="loading">Fechar</app-button>
  <app-button (btnClick)="confirm()" [disabled]="loading"> Adicionar colaborador </app-button>
</mat-dialog-actions>

@if (loading) {
  <app-loading />
}
